export enum ROUTE_PATH {
    WELCOME = '',
    BOOTH_CAPTAIN_AGREEMENT = 'booth-captain-agreement',
    LOCATION_SELECTION = 'locations',
    SHIFT_SELECTION = 'shifts',
    SUMMARY = 'summary',
    SHARED_SCHEDULE = 'shared-schedule',
    REGISTERED_VOLUNTEERS = 'registered-volunteers',
}
